"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.settlementsForAllPortfoliosQuery = exports.settlementsQuery = exports.historicalInstructionsQuery = exports.buildHistoricalInstructionsQueryFilter = exports.legsQuery = exports.offChainAffirmationsQuery = exports.instructionAffirmationsQuery = exports.instructionsQuery = exports.instructionEventsQuery = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const common_1 = require("./common");
const types_1 = require("../types");
const constants_1 = require("../../utils/constants");
const internal_1 = require("../../utils/internal");
const legAttributes = `
            legIndex
            legType
            from
            fromPortfolio
            to
            toPortfolio
            assetId
            ticker
            amount
            nftIds
            addresses
            offChainReceipts {
              nodes {
                uid
                signer
              }
            }
`;
const instructionAttributes = `
          id
          venueId
          status
          type
          endBlock
          endAfterBlock
          tradeDate
          valueDate
          mediators
          legs {
            nodes {
              ${legAttributes}
            }
          }
          memo
          createdBlock {
            blockId
            hash
            datetime
          }
          updatedBlock {
            blockId
            hash
            datetime
          }
`;
const instructionAffirmationAttributes = `
      id
      identity
      portfolios
      offChainReceiptId
      offChainReceipt {
        leg {
          id
          legIndex
        }
        signer
      }
      status
      isAutomaticallyAffirmed
      isMediator
      expiry
`;
/**
 * Query to get event details about instruction events
 */
function instructionEventsQuery(paddedIds, filters, size, start) {
    const { args, filter } = (0, common_1.createArgsAndFilters)(filters, {
        event: 'InstructionEventEnum',
    });
    let orderBy = `[${types_1.InstructionEventsOrderBy.CreatedAtDesc}, ${types_1.InstructionEventsOrderBy.CreatedBlockIdDesc}]`;
    if (paddedIds) {
        orderBy = `[${types_1.InstructionEventsOrderBy.CreatedEventIdDesc}]`;
    }
    const query = (0, graphql_tag_1.default) `
    query InstructionEventsQuery
      ${args}
      {
      instructionEvents(
        ${filter}
        first: $size
        offset: $start
        orderBy: ${orderBy}
      ) {
        totalCount
        nodes {
          id
          event
          eventIdx
          identity
          portfolio
          offChainReceiptId
          offChainReceipt {
            legId
            signer
            uid
          }
          createdBlock {
            blockId
            hash
            datetime
          }
          updatedBlock {
            blockId
            hash
            datetime
          }
        }
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, filters), (0, common_1.getSizeAndOffset)(size, start)),
    };
}
exports.instructionEventsQuery = instructionEventsQuery;
/**
 * @hidden
 *
 * Get a specific instruction within a venue for a specific event
 */
function instructionsQuery(paddedIds, filters, size, start) {
    const { args, filter } = (0, common_1.createArgsAndFilters)(filters, {
        status: 'InstructionStatusEnum',
    });
    let orderBy = `[${types_1.InstructionsOrderBy.CreatedAtDesc}, ${types_1.InstructionsOrderBy.IdDesc}]`;
    if (paddedIds) {
        orderBy = `[${types_1.InstructionsOrderBy.CreatedEventIdDesc}]`;
    }
    const query = (0, graphql_tag_1.default) `
    query InstructionsQuery
      ${args}
      {
      instructions(
        ${filter}
        first: $size
        offset: $start
        orderBy: ${orderBy}
      ) {
        totalCount
        nodes {
          ${instructionAttributes}
        }
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, filters), (0, common_1.getSizeAndOffset)(size, start)),
    };
}
exports.instructionsQuery = instructionsQuery;
/**
 * @hidden
 *
 * Get a specific instruction within a venue for a specific event
 */
function instructionAffirmationsQuery(paddedIds, filters, size, start) {
    const { args, filter } = (0, common_1.createArgsAndFilters)(filters, {
        status: 'AffirmStatusEnum',
        isMediator: 'Boolean',
    });
    const orderBy = paddedIds
        ? `[${types_1.InstructionAffirmationsOrderBy.CreatedBlockIdDesc}]`
        : `[${types_1.InstructionAffirmationsOrderBy.CreatedAtAsc}, ${types_1.InstructionAffirmationsOrderBy.CreatedBlockIdAsc}]`;
    const query = (0, graphql_tag_1.default) `
    query InstructionAffirmationsQuery
      ${args}
      {
      instructionAffirmations(
        ${filter}
        first: $size
        offset: $start
        orderBy: ${orderBy}
      ) {
        totalCount
        nodes {
          ${instructionAffirmationAttributes}
        }
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, filters), { size: size === null || size === void 0 ? void 0 : size.toNumber(), start: start === null || start === void 0 ? void 0 : start.toNumber() }),
    };
}
exports.instructionAffirmationsQuery = instructionAffirmationsQuery;
/**
 * @hidden
 *
 * Get a specific instruction within a venue for a specific event
 */
function offChainAffirmationsQuery(paddedIds, filters) {
    const orderBy = paddedIds
        ? `${types_1.InstructionAffirmationsOrderBy.CreatedBlockIdAsc}`
        : `${types_1.InstructionAffirmationsOrderBy.CreatedAtAsc}, ${types_1.InstructionAffirmationsOrderBy.CreatedBlockIdAsc}`;
    const query = (0, graphql_tag_1.default) `
    query InstructionAffirmationsQuery($instructionId: String!) {
      instructionAffirmations(
        filter: {
          instructionId: { equalTo: $instructionId }
          offChainReceiptExists: true
        }
        orderBy: [${orderBy}]
      ) {
        nodes {
          ${instructionAffirmationAttributes}
        }
      }
    }
  `;
    return {
        query,
        variables: Object.assign({}, filters),
    };
}
exports.offChainAffirmationsQuery = offChainAffirmationsQuery;
/**
 * @hidden
 *
 * Get a specific instruction within a venue for a specific event
 */
function legsQuery(filters, size, start) {
    const { args, filter } = (0, common_1.createArgsAndFilters)(filters, {
        legType: 'LegTypeEnum',
        legIndex: 'Int',
    });
    const query = (0, graphql_tag_1.default) `
    query LegsQuery
      ${args}
      {
      legs(
        ${filter}
        first: $size
        offset: $start
        orderBy: [${types_1.LegsOrderBy.LegIndexAsc}]
      ) {
        totalCount
        nodes {
          ${legAttributes}
        }
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, filters), { size: size === null || size === void 0 ? void 0 : size.toNumber(), start: start === null || start === void 0 ? void 0 : start.toNumber() }),
    };
}
exports.legsQuery = legsQuery;
/**
 * @hidden
 *
 */
const buildHistoricalInstructionsQueryFilter = (filters, context) => __awaiter(void 0, void 0, void 0, function* () {
    const { identity, asset, status, sender, receiver, mediator, party, size = new bignumber_js_1.default(constants_1.DEFAULT_GQL_PAGE_SIZE), start = new bignumber_js_1.default(0), } = filters;
    const args = ['$start: Int', '$size: Int'];
    const baseFilter = [];
    const instructionPartiesFilter = [];
    const legsFilter = [];
    const variables = {};
    if (identity) {
        args.push('$identity: String!');
        instructionPartiesFilter.push('identity: { equalTo: $identity }');
        variables.identity = (0, internal_1.asDid)(identity);
    }
    if (mediator) {
        args.push('$mediator: String!');
        baseFilter.push('mediators: { containsKey: $mediator }');
        variables.mediator = (0, internal_1.asDid)(mediator);
    }
    if (status) {
        args.push('$status: InstructionStatusEnum!');
        baseFilter.push('status: { equalTo: $status }');
        variables.status = status;
    }
    if (party) {
        args.push('$party: String!');
        instructionPartiesFilter.push('identity: { equalTo: $party }');
        variables.party = (0, internal_1.asDid)(party);
    }
    if (asset) {
        args.push('$asset: String!');
        legsFilter.push('assetId: { equalTo: $asset }');
        variables.asset = yield (0, internal_1.asAssetId)(asset, context);
    }
    if (sender) {
        args.push('$sender: String!');
        legsFilter.push('from: { equalTo: $sender }');
        variables.sender = (0, internal_1.asDid)(sender);
    }
    if (receiver) {
        args.push('$receiver: String!');
        legsFilter.push('to: { equalTo: $receiver }');
        variables.receiver = (0, internal_1.asDid)(receiver);
    }
    if (legsFilter.length) {
        baseFilter.push(`legs: { some: { ${legsFilter.join(', ')} } }`);
    }
    if (instructionPartiesFilter.length) {
        baseFilter.push(`parties: { some: { ${instructionPartiesFilter.join(', ')} } }`);
    }
    return {
        args: `(${args.join()})`,
        filter: baseFilter.length ? `filter: { ${baseFilter.join(', ')} }` : '',
        variables: Object.assign(Object.assign({}, variables), (0, common_1.getSizeAndOffset)(size, start)),
    };
});
exports.buildHistoricalInstructionsQueryFilter = buildHistoricalInstructionsQueryFilter;
/**
 * @hidden
 *
 * Get Instructions where an identity is involved
 */
function historicalInstructionsQuery(filters, context) {
    return __awaiter(this, void 0, void 0, function* () {
        const { args, filter, variables } = yield (0, exports.buildHistoricalInstructionsQueryFilter)(filters, context);
        const paddedIds = context.isSqIdPadded;
        const orderBy = paddedIds
            ? `[${types_1.InstructionsOrderBy.CreatedBlockIdAsc}]`
            : `[${types_1.InstructionsOrderBy.CreatedAtAsc}, ${types_1.InstructionsOrderBy.IdAsc}]`;
        const query = (0, graphql_tag_1.default) `
    query InstructionsQuery
    ${args}
     {
      instructions(
        ${filter}
        orderBy: ${orderBy}
        first: $size
        offset: $start
      ) {
        nodes {
            ${instructionAttributes}
        }
        totalCount
      }
    }
  `;
        return {
            query,
            variables,
        };
    });
}
exports.historicalInstructionsQuery = historicalInstructionsQuery;
/**
 *  @hidden
 */
function createLegFilters({ identityId, portfolioId, assetId, address }, queryAll) {
    const args = ['$from: String!, $to: String!'];
    const fromIdFilters = ['from: { equalTo: $from }'];
    const toIdFilters = ['to: { equalTo: $to }'];
    const portfolioNumber = portfolioId ? portfolioId.toNumber() : 0;
    const variables = {
        from: identityId,
        to: identityId,
    };
    if (!queryAll) {
        variables.fromPortfolio = portfolioNumber;
        variables.toPortfolio = portfolioNumber;
        args.push('$fromPortfolio: Int, $toPortfolio: Int');
        fromIdFilters.push('fromPortfolio: { equalTo: $fromPortfolio }');
        toIdFilters.push('toPortfolio: { equalTo: $toPortfolio }');
    }
    if (assetId) {
        variables.assetId = assetId;
        args.push('$assetId: String!');
        const assetIdFilter = 'assetId: { equalTo: $assetId }';
        toIdFilters.push(assetIdFilter);
        fromIdFilters.push(assetIdFilter);
    }
    if (address) {
        variables.addresses = [address];
        args.push('$addresses: [String!]!');
        const addressFilter = 'addresses: { in: $addresses }';
        toIdFilters.push(addressFilter);
        fromIdFilters.push(addressFilter);
    }
    return {
        args: `(${args.join()})`,
        filter: `filter: { or: [{ ${fromIdFilters.join()} }, { ${toIdFilters.join()} } ] }`,
        variables,
    };
}
/**
 *  @hidden
 */
function buildSettlementsQuery(paddedIds, args, filter) {
    const orderBy = paddedIds
        ? `[${types_1.LegsOrderBy.CreatedBlockIdAsc}]`
        : `[${types_1.LegsOrderBy.CreatedAtAsc}, ${types_1.LegsOrderBy.InstructionIdAsc}]`;
    return (0, graphql_tag_1.default) `
  query SettlementsQuery
    ${args}
   {
    legs(
      ${filter}
      orderBy: ${orderBy}
    ) {
      nodes {
        instruction {
          ${instructionAttributes}
        }
      }
    }
  }
`;
}
/**
 * @hidden
 *
 * Get Settlements where a Portfolio is involved
 */
function settlementsQuery(paddedIds, filters) {
    const { args, filter, variables } = createLegFilters(filters);
    const query = buildSettlementsQuery(paddedIds, args, filter);
    return {
        query,
        variables,
    };
}
exports.settlementsQuery = settlementsQuery;
/**
 * @hidden
 *
 * Get Settlements for all Portfolios
 */
function settlementsForAllPortfoliosQuery(paddedIds, filters) {
    const { args, filter, variables } = createLegFilters(filters, true);
    const query = buildSettlementsQuery(paddedIds, args, filter);
    return {
        query,
        variables,
    };
}
exports.settlementsForAllPortfoliosQuery = settlementsForAllPortfoliosQuery;
//# sourceMappingURL=settlements.js.map